<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow mt-0">
            <div class="card-header card-header-primary negative blue-grad w-50 d-flex">
              <button class="btn btn-sm btn-link" @click="$router.go(-1)">
                <i class="fa fa-chevron-left"></i> {{ $t("message.back") }}
              </button>
              <h4 class="card-title">{{ $t("message.admin.translations.translations") }}</h4>
            </div>
            <div class="card-body px-3">
              <button @click="add" class="btn btn-success btn-sm">
                {{ $t("message.admin.translations.add") }}
              </button>
              <b-table :items="translations" :fields="translations_fields" :per-page="per_page"
                :current-page="current_page" @row-clicked="edit"></b-table>
              <div class="d-flex justify-content-center">
                <b-pagination v-model="current_page" :total-rows="translations.length"
                  :per-page="per_page"></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-translation" :hide-footer="true" size="lg"
      :title="is_add ? $t('message.admin.translations.add_translation') : $t('message.admin.translations.edit_translation')"
      button-size="lg">
      <div class="form-gro2up mb-3">
        <label for="service_code">
          {{ $t("message.admin.translations.service_code") }}
        </label>
        <input type="number" v-model="translation.ApiService" id="service_code" class="form-control" />
      </div>
      <div class="form-gro2up mb-3">
        <label for="category">
          {{ $t("message.admin.translations.category") }}
        </label>
        <input type="text" v-model="translation.DataCategory" id="category" class="form-control" />
      </div>
      <div class="form-gro2up mb-3">
        <label for="field_name_cn">
          {{ $t("message.admin.translations.field_name_cn") }}
        </label>
        <input type="text" v-model="translation.ApiFieldNameCn" id="field_name_cn" class="form-control" />
      </div>
      <div class="form-gro2up mb-3">
        <label for="field_data_cn">
          {{ $t("message.admin.translations.field_data_cn") }}
        </label>
        <input type="text" v-model="translation.ApiFieldDataCn" id="field_data_cn" class="form-control" />
      </div>
      <div class="form-gro2up mb-3">
        <label for="field_name_ru">
          {{ $t("message.admin.translations.field_name_ru") }}
        </label>
        <input type="text" v-model="translation.ApiFieldNameRu" id="field_name_ru" class="form-control" />
      </div>
      <div class="form-gro2up mb-3">
        <label for="field_data_ru">
          {{ $t("message.admin.translations.field_data_ru") }}
        </label>
        <input type="text" v-model="translation.ApiFieldDataRu" id="field_data_ru" class="form-control" />
      </div>
      <div class="form-gro2up mb-3">
        <label for="field_name_en">
          {{ $t("message.admin.translations.field_name_en") }}
        </label>
        <input type="text" v-model="translation.ApiFieldNameEn" id="field_name_en" class="form-control" />
      </div>
      <div class="form-gro2up mb-3">
        <label for="field_data_en">
          {{ $t("message.admin.translations.field_data_en") }}
        </label>
        <input type="text" v-model="translation.ApiFieldDataEn" id="field_data_en" class="form-control" />
      </div>

      <div class="text-right">
        <button v-if="is_edit" @click="del" class="btn btn-danger btn-sm mr-2">
          {{ $t("message.admin.translations.delete") }}
        </button>
        <button @click="action" class="btn btn-success btn-sm">
          {{ is_add ? $t("message.admin.translations.add") : $t("message.admin.translations.edit") }}
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
const initialTranslation = {
  Id: null,
  ApiService: "",
  DataCategory: "",
  ApiFieldNameCn: "",
  ApiFieldDataCn: "",
  ApiFieldNameRu: "",
  ApiFieldDataRu: "",
  ApiFieldNameEn: "",
  ApiFieldDataEn: "",
};
export default {
  name: "admin-translations",
  mounted() {
    if (!this.$store.state.auth) this.$router.push({ name: "sign-in" });
    this.load();
  },
  data() {
    return {
      current_page: 0,
      per_page: 20,
      translations: [],

      is_add: false,
      is_edit: false,

      translation: { ...initialTranslation },

      translations_fields: [
        {
          key: "ApiService",
          label: this.$t("message.admin.translations.service_code"),
          class: ["line-clamp-1"],
          thClass: ["line-clamp-1"],
        },
        {
          key: "DataCategory",
          label: this.$t("message.admin.translations.category"),
          class: ["line-clamp-1"],
          thClass: ["line-clamp-1"],
        },
        {
          key: "ApiFieldNameCn",
          label: this.$t("message.admin.translations.field_name_cn"),
          class: ["line-clamp-1"],
          thClass: ["line-clamp-1"],
        },
        {
          key: "ApiFieldDataCn",
          label: this.$t("message.admin.translations.field_data_cn"),
          class: ["line-clamp-1"],
          thClass: ["line-clamp-1"],
        },
        {
          key: "ApiFieldNameRu",
          label: this.$t("message.admin.translations.field_name_ru"),
          class: ["line-clamp-1"],
          thClass: ["line-clamp-1"],
        },
        {
          key: "ApiFieldDataRu",
          label: this.$t("message.admin.translations.field_data_ru"),
          class: ["line-clamp-1"],
          thClass: ["line-clamp-1"],
        },
        {
          key: "ApiFieldNameEn",
          label: this.$t("message.admin.translations.field_name_en"),
          class: ["line-clamp-1"],
          thClass: ["line-clamp-1"],
        },
        {
          key: "ApiFieldDataEn",
          label: this.$t("message.admin.translations.field_data_en"),
          class: ["line-clamp-1"],
          thClass: ["line-clamp-1"],
        },
      ],
    };
  },
  methods: {
    load() {
      axios.get(window.base + "/SearchTranslate/GetAll").then((response) => {
        try {
          this.translations = response.data;
        } catch (e) {
          new Noty({
            theme: "light",
            type: "error",
            text: this.$t("message.admin.translations.error_json"),
            timeout: 5000,
          }).show();
        }
      });
    },
    add() {
      this.translation = { ...initialTranslation };
      this.is_add = true;
      this.is_edit = false;
      this.$bvModal.show("modal-translation");
    },
    edit(translation) {
      this.translation = { ...translation };
      this.is_edit = true;
      this.is_add = false;
      this.$bvModal.show("modal-translation");
    },
    action() {
      if (this.is_add) {
        axios.post(window.base + "/SearchTranslate/Add", this.translation).then((response) => {
          this.load();
          this.$bvModal.hide("modal-translation");
        });
      } else {
        axios.post(window.base + "/SearchTranslate/Update", this.translation).then((response) => {
          this.load();
          this.$bvModal.hide("modal-translation");
        });
      }
    },
    del() {
      axios.post(window.base + "/SearchTranslate/Delete", { Id: this.translation.Id }).then((response) => {
        this.load();
        this.$bvModal.hide("modal-translation");
      });
    },
  },
};
</script>
<style>
table {
  table-layout: fixed;
  width: 100%;
}

table td {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
